export default "__VITE_ASSET__Cf19zlWR__"